export const TARGET_ACTOR = '[TARGET ACTOR]'
export const SELECT_ACTOR = `${TARGET_ACTOR} Select actor from battle`
export const CHECK_SELECTED_ACTOR = `${TARGET_ACTOR} Check selected actor for validity`

export const selectTargetActor = actor => ({
    type: SELECT_ACTOR,
    payload: {
        actor,
    },
    meta: {
        targetActor: 'checkSame',
    },
})

export const checkSelectedTargetActor = () => ({
    type: CHECK_SELECTED_ACTOR,
    payload: {},
    meta: {
        targetActor: 'checkDeath',
    },
})
